import { render, staticRenderFns } from "./oceanShippingInformation_Component.vue?vue&type=template&id=37bcdfe2&scoped=true&"
import script from "./oceanShippingInformation_Component.vue?vue&type=script&lang=js&"
export * from "./oceanShippingInformation_Component.vue?vue&type=script&lang=js&"
import style0 from "./oceanShippingInformation_Component.vue?vue&type=style&index=0&id=37bcdfe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bcdfe2",
  null
  
)

export default component.exports